<template>
	<card header-classes="bg-dark">
		<template slot="header">
			<h3 class="mb-0 text-white">ตั้งค่า AMB Payment</h3>
		</template>
		<form @submit.prevent="saveConfig">
			<base-input label="Username" placeholder="Username" v-model="username" />
			<base-input label="Secret" placeholder="Secret" v-model="secret" />

			<div class="mt-3">
				<base-button native-type="submit" type="default" :disabled="loading">
					บันทึกข้อมูล
				</base-button>
			</div>
		</form>
	</card>
</template>

<script>
import SettingService from '../../services/setting.service'

export default {
	props: ['setting'],
	name: 'AMBPaymentPanel',
	data() {
		return {
			loading: false,

			username: '',
			secret: '',
		}
	},
	methods: {
		async saveConfig() {
			this.loading = true

			try {
				const res = await SettingService.saveAMBPayment({
					username: this.username,
					secret: this.secret,
				})

				this.$notify({ type: 'success', message: res.message })
			} catch ({ message }) {
				this.$notify({ type: 'danger', message: message })
			} finally {
				this.loading = false
			}
		},
	},
	created() {
		this.username = this.setting.username
		this.secret = this.setting.secret
	},
	watch: {
		setting(v) {
			console.log(v)
			if (v) {
				this.username = v.username
				this.secret = v.secret
			}
		},
	},
}
</script>
